/**
 * Mirrors packages/amghighlow_v2/lib/core/constants/api_constants.dart
 * + game_constants.dart for endpoints, game key, and reference resolution.
 *
 * HighLow has no multiplayer (single-player only).
 */
export const API_BASE = 'https://staginggameapi.tbgcablecar.xyz/api';

export const Endpoints = {
  login: `${API_BASE}/action/login`,
  openGame: `${API_BASE}/action/opengame`,
  checkBalance: `${API_BASE}/action/balance`,
  getInfo: `${API_BASE}/action/getinfo`,
  placeBet: `${API_BASE}/action/bet`,
} as const;

export const GAME_KEY_SINGLE = 'HLW1';
export const DEFAULT_AGENT_ID = 'Agent1';

/** Reference stage size — mirrors apps/amg_highlow_v2 design dims. */
export const REF_WIDTH = 1792;
export const REF_HEIGHT = 828;

/** Hard-coded test credentials — match the Flutter LobbyScreen defaults. */
export const DEFAULT_USER_NAME = 'user10';
export const DEFAULT_PASSWORD = '123456';

/** Default game config — used until /action/getinfo overrides. */
export const DEFAULT_GAME_CONFIG = {
  minBet: 50,
  maxBet: 1000,
  chipValues: [50, 100, 200, 500, 800, 1000] as const,
};

/** Number of betting rounds per cycle (after 3 → shuffle and start over). */
export const ROUNDS_PER_CYCLE = 3;
/** Total card slots: 2 per round (start card + result card). */
export const CARDS_PER_CYCLE = ROUNDS_PER_CYCLE * 2;
